function goToEditPage(pageType: string, title: string) {
   if (!title) {
      return;
   }
   title = encodeURIComponent(title.trim());
   let location = '/' + pageType + '/Edit/' + title;

   switch (pageType) {
      case 'guide': {
         const topicTitle = title ? App.newGuideObject + '/' + title : '';
         location = window.guide_constants.GuideURI('TAG_GUIDE_CREATE') + '/' + topicTitle;
         break;
      }

      default: {
         break;
      }
   }

   window.location.href = location;
}

export { goToEditPage };
